import React from 'react'
import {FaGithub, FaTwitter, FaLinkedinIn, FaEnvelope, FaInstagram} from 'react-icons/fa';
import profile from '../Images/bn.gif'

export default function Footer() {
  return (
    <div>
       <div className='flex align-center justify-center mt-60'>
                      
                      <a rel="noreferrer" className='hover:animate-bounce text-xl m-1 p-1 sm:m-2 sm:p-2 text-pink-700 rounded-full transition-colors duration-300' href='https://instagram.com/_anuraag_' target="_blank">
                        <FaInstagram/>
                        <span className='sr-only'>Instagram</span>
                      </a>

                      <a rel="noreferrer" className='hover:animate-bounce text-xl m-1 p-1 sm:m-2 sm:p-2 text-sky-400 rounded-full transition-colors duration-300' href='https://twitter.com/anurrag_' target="_blank">
                        <FaTwitter/>
                        <span className='sr-only'>Twitter</span>
                      </a>

                      <a rel="noreferrer" className='hover:animate-bounce text-xl m-1 p-1 sm:m-2 sm:p-2 text-white rounded-full transition-colors duration-300' href='https://github.com/singhanurrag' target="_blank">
                        <FaGithub/>
                        <span className='sr-only'>Github</span>
                      </a>

                      <a rel="noreferrer" className='hover:animate-bounce text-xl m-1 p-1 sm:m-2 sm:p-2 text-blue-700  rounded-full transition-colors duration-300' href='https://www.linkedin.com/in/anuragsbhadauria/' target="_blank">
                        <FaLinkedinIn/>
                        <span className='sr-only'>LinkedIn</span>
                      </a>

                      <a rel="noreferrer" className='hover:animate-bounce text-xl m-1 p-1 sm:m-2 sm:p-2 text-orange-500  rounded-full transition-colors duration-300' href='https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=bhadauriaanurag2000@gmail.com' target="_blank">
                        <FaEnvelope/>
                        <span className='sr-only'>FaEnvelope</span>
                      </a>
                  </div>
                  <div className='flex justify-center mb-1 text-xm sm:xl text-slate-400'>
                        Made with&nbsp;<img className='flex justify-center w-7 h-7 hover:animate-spin' src={profile} alt=''/>&nbsp;by&nbsp; <a className='text-white hover:text-red-500' href='#'>Anurag</a>
                  </div>
                  <div className='flex justify-center mb-0 text-xs text-slate-400 mb-0'>
                         2022 ©️ Anurag 
                  </div>
    </div>
  )
}
